import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { nonEmptyString } from "../../shared/src/codecs/types/nonEmptyString";
import { required } from "../../shared/src/codecs/types/required";
import { requiredFlatOverloaded } from "../../shared/src/codecs/types/requiredFlatOverloaded";
import { intersection } from "../../shared/src/codecs/types/intersection";
import { DeleteProofOfFundsDocumentFormIO } from "./formIO/DeleteProofOfFundsDocumentFormIO";
import * as S3BucketUrl from "../../domain/models/S3BucketUrl";
import { overload } from "../../shared/src/codecs/types/overload";
import { string } from "../../shared/src/codecs/types/string";

const getProofOfFundsDocumentUrl = (id: string, file_extension: string) =>
    `${S3BucketUrl.fromAccountAndBucketNames(process.env.ACCOUNT_NAME ?? "", S3BucketUrl.bucketNames.LISTINGS_DOCUMENTS_BUCKET)}/${id}/${id}.${file_extension}`;

// Codec 1: flat DB record
export const ProofOfFundsDocument1 = required({
    id: uuid(),
    listings_enquiry_id: uuid(),
    name: nonEmptyString(),
    file_extension: nonEmptyString(),
    mime_type: nonEmptyString(),
});
export type TProofOfFundsDocument1Codec = typeof ProofOfFundsDocument1;
export type TProofOfFundsDocument1 = TTypeOfCodec<typeof ProofOfFundsDocument1>;

// Codec 2: full output shape (with overloaded URL and delete form)
export const ProofOfFundsDocument2 = intersection([
    required({
        id: uuid(),
        listings_enquiry_id: uuid(),
        name: nonEmptyString(),
        file_extension: nonEmptyString(),
        mime_type: nonEmptyString(),
    }),
    requiredFlatOverloaded({
        delete_form: DeleteProofOfFundsDocumentFormIO,
    }),
    requiredFlatOverloaded({
        url: overload(
            string(),
            required({ id: uuid(), file_extension: string() }),
            (t) => t ? getProofOfFundsDocumentUrl(t.id, t.file_extension) : "",
        ),
    }),
]);
export type TProofOfFundsDocument2Codec = typeof ProofOfFundsDocument2;
export type TProofOfFundsDocument2 = TTypeOfCodec<typeof ProofOfFundsDocument2>;

// Codec 3: input shape for upload
export const ProofOfFundsDocument3 = required({
    listings_enquiry_id: uuid(),
    name: nonEmptyString(),
    file_extension: nonEmptyString(),
    mime_type: nonEmptyString(),
});
export type TProofOfFundsDocument3Codec = typeof ProofOfFundsDocument3;
export type TProofOfFundsDocument3 = TTypeOfCodec<typeof ProofOfFundsDocument3>;
